import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-agreements-nasdaq-fine-print',
  templateUrl: 'agreements-nasdaq-fine-print.component.html',
  styleUrls: ['agreements-fine-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgreementsNasdaqFinePrintComponent  {
  namespace: string = 'tdWb.platform.preferences.agreements.fineprints';
}
